import { Navigate, createBrowserRouter } from 'react-router-dom'

import AdminRoute from 'routes/AdminRoute'
import Loadable from 'components/Loadable'
import MainLayout from 'layout/MainLayout'
import ProtectedRoute from 'routes/ProtectedRoute'
import config from 'config'
import { lazy } from 'react'

// Views
const CollectionsPage = Loadable(lazy(() => import('views/collections')))
const ItemsPage = Loadable(lazy(() => import('views/items')))
const TasksPage = Loadable(lazy(() => import('views/tasks')))
const CreateCollectionView = Loadable(lazy(() => import('views/create-collection')))
const ObjectBrowser = Loadable(lazy(() => import('views/object-browser')))
const ObjectStorage = Loadable(lazy(() => import('views/object-storage')))
const ObjectStorageCreate = Loadable(lazy(() => import('views/object-storage/create-storage')))
const ObjectStorageCredentials = Loadable(lazy(() => import('views/object-storage/credentials')))
const DataExplorerPage = Loadable(lazy(() => import('views/explorer')))
const UploadPage = Loadable(lazy(() => import('views/upload')))
const FileFormatDoc = Loadable(lazy(() => import('views/documentation/FileFormatDoc')))

const router = createBrowserRouter(
  [
    // Public route for documentation (no auth, no layout)
    {
      path: '/docs/file-formats/:formatName',
      element: <FileFormatDoc />
    },
    // Protected routes
    {
      path: '/',
      element: <ProtectedRoute />,
      children: [
        {
          element: <MainLayout />,
          children: [
            { index: true, element: <Navigate to="/explorer" replace /> },
            { path: 'explorer', element: <DataExplorerPage /> },

            // Protected Admin Routes
            {
              element: <AdminRoute />,
              children: [
                { path: 'collections', element: <CollectionsPage /> },
                { path: 'collections/:id', element: <CreateCollectionView /> },
                { path: 'items', element: <ItemsPage /> },
                { path: 'tasks', element: <TasksPage /> },
                { path: 'upload', element: <UploadPage /> },
                { path: 'storage', element: <ObjectStorage /> },
                { path: 'storage/:id', element: <ObjectStorageCreate /> },
                { path: 'storage/:id/credentials', element: <ObjectStorageCredentials /> },
                { path: 'storage/:id/explore', element: <ObjectBrowser /> }
              ]
            }
          ]
        }
      ]
    }
  ],
  { basename: config.basename }
)

export default router
